import { onMount, createSignal } from "solid-js";
import { render } from "solid-js/web";

function PortfolioInfo({ content }) {
    const [open, setOpen] = createSignal(false);

    function initSmall(ref) {
        ref.appendChild(content.querySelector(".content-title").cloneNode(true));
    }

    function initBig(ref) {
        ref.appendChild(content);
        ref.querySelector("#close-button").onclick = () => setOpen(false);
    }

    return <>
        <div ref={initSmall} class="!mt-4" classList={{ "hidden": open() }} onClick={ () => setOpen(true) }></div>
        <div ref={initBig} classList={{ "hidden": !open() }}></div>
    </>;
}

document.addEventListener("DOMContentLoaded", () => {
    const element = document.querySelector("#portfolio-info");
    if (!element) return;

    const content = element.cloneNode(true);
    element.replaceChildren([]);

    render(() => <PortfolioInfo content={content}/>, element);
    element.classList.add("show");
});

